<template>
  <div class="card">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <div class="card-label">
            <h3 class="card-label">{{ $t('absences.calendar_view') }}</h3>
            <p class="text-muted">{{ $t('absences.list') }}</p>
          </div>
        </div>
        <div class="card-toolbar">
          <Button type="new" btn-class="btn-sm me-2" @click="openCreateAbsenceModal" btn-text="absences.demand"></Button>
        </div>
      </div>
      <div class="card-body">
        <Calendar v-if="events.length" id="calendarUserAbsenceId" :headerToolbar="false" :event="events" :size="size"/>
      </div>
  </div>
  <CreateModal id="create_absence_on_calendar_modal" @load="loadAbsence" :nbrHolidays="currentUser?.nbrHolidays"/>
</template>

<script setup>
import {onMounted, ref, watch, computed} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import Calendar from "@/components/CalendarSimple.vue"
import CreateModal from "./Modals/CreateModal"
import Button from "@/components/Button";

const route = useRoute()

const store = useStore()

const absencesData = ref({})

const events = ref([]);

const currentUser = computed(() => store.getters['user/currentUser'])

watch(() => absencesData.value, (value) => {
  getData();
}, { deep: true });

const size = ref({
    contentHeight: 500,
    height: 500
})

function getData() {
  events.value = absencesData.value.map((item) => ({
      title: item?.title || "Sans titre",
      start: item?.start,
      end: item?.end,
      extendedProps: {
          id: item?.id || null,
          startTime: item?.start || null,
          endTime: item?.end || null,
          color: item?.color || "#0072CE"
      }
  }));
  document.getElementById("calendarUserAbsenceId")?.dispatchEvent(new Event("refresh"));
}

function openCreateAbsenceModal(){
  $('#create_absence_on_calendar_modal').modal('toggle')
}

async function loadAbsence() {
  await store.dispatch('absences/loadAbsences').then((res) => {
    let data = res.data.holidays
    absencesData.value = data
  })
}

onMounted(async() => {
  if(route.query.viewType == 'calendar'){
    loadAbsence()
    document.getElementById("calendarUserAbsenceId")?.dispatchEvent(new Event("refresh"));
  }
})


</script>
